import { ScrollService, scrollService } from '@core/js/services/scroll.service';

class ExtendedScrollService extends ScrollService {
    saveScrollTop = (n = 0) => {
        this.savedScroll = n || this.scrollEl.scrollTop;
        return this.savedScroll;
    };

    restoreScrollY = () => {
        this.scrollEl.scrollTo(0, this.savedScroll);
    };
}

export const extendedScrollService = new ExtendedScrollService();

class ScrollServiceRegistry {
    services = new Map();

    getService(key) {
        if (!this.services.has(key)) {
            this.services.set(key, new ExtendedScrollService());
        }

        return this.services.get(key);
    }

    clearService(key) {
        this.services.delete(key);
    }

    clearAll() {
        this.services.clear();
    }
}

export const scrollServiceRegistry = new ScrollServiceRegistry();

export { ExtendedScrollService, ScrollService, scrollService };
